import { phone as formatPhone } from 'phone'
import {
  post as apiPost,
  TYPE_BROOKLYN_JSON,
} from 'api-client'
import _get from 'lodash/get'

// this is United States only
export const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/im // eslint-disable-line

export const WISHROUTE_SIGNUP_START = 'start'

// New Relic event types
export const WISHROUTE_EVENT_FORM_RENDERED = 'formRendered'
export const WISHROUTE_EVENT_OPT_IN = 'optIn'

// values
export const WISHROUTE_VALUE_ALTERNATIVE_HEALING = 'alternative_healing'
export const WISHROUTE_VALUE_MEDITATION = 'meditation'
export const WISHROUTE_VALUE_FITNESS = 'fitness'
export const WISHROUTE_VALUE_YOGA = 'yoga'
export const WISHROUTE_VALUE_METAPHYSICS = 'metaphysics'
export const WISHROUTE_VALUE_EXPANDED_CONSCIOUSNESS = 'expanded_consciousness'
export const WISHROUTE_VALUE_INSPIRING_FILMS = 'inspiring_films'
export const WISHROUTE_VALUE_SPIRITUAL_GROWTH = 'spiritual_growth'
export const WISHROUTE_VALUE_ANCIENT_ORIGINS = 'ancient_origins'
export const WISHROUTE_VALUE_PARANORMAL = 'paranormal'
export const WISHROUTE_VALUE_SECRETS_COVERUPS = 'secrets_and_coverups'
export const WISHROUTE_VALUE_YOGA_LEVEL_BEGINNER = 'beginner'
export const WISHROUTE_VALUE_YOGA_LEVEL_INTERMEDIATE = 'intermediate'
export const WISHROUTE_VALUE_YOGA_LEVEL_ADVANCED = 'advanced'
export const WISHROUTE_VALUE_ENERGIZED = 'energized'
export const WISHROUTE_VALUE_BENDY_FLEXIBLE = 'bendy_and_flexible'
export const WISHROUTE_VALUE_READY_BED = 'ready_for_bed'
export const WISHROUTE_VALUE_STRESS_FREE = 'stress_free'
export const WISHROUTE_VALUE_FIT_STRONG = 'fit_and_strong'
export const WISHROUTE_VALUE_NOT_SURE = 'not_sure'
export const WISHROUTE_VALUE_PRESENT = 'present'
export const WISHROUTE_VALUE_FOCUSED = 'focused'
export const WISHROUTE_VALUE_EASTERN_ARTS = 'eastern_arts'
export const WISHROUTE_VALUE_WEIGHT_TRAIN = 'weight_train'
export const WISHROUTE_VALUE_DANCE_FITNESS = 'dance_fitness'
export const WISHROUTE_VALUE_STRETCH = 'stretch'
export const WISHROUTE_VALUE_PILATES = 'pilates'
export const WISHROUTE_VALUE_CARDIO = 'cardio'

export function getWishrouteValue (tid) {
  switch (tid) {
    case 121891:
    case 122274:
      return WISHROUTE_VALUE_ANCIENT_ORIGINS
    case 121889:
    case 122278:
      return WISHROUTE_VALUE_PARANORMAL
    case 121894:
    case 122270:
    case 122191:
    case 121863:
      return WISHROUTE_VALUE_ALTERNATIVE_HEALING
    case 121942:
    case 122273:
      return WISHROUTE_VALUE_YOGA
    case 121890:
    case 122279:
      return WISHROUTE_VALUE_SECRETS_COVERUPS
    case 121893:
    case 122276:
      return WISHROUTE_VALUE_INSPIRING_FILMS
    case 121944:
    case 122272:
      return WISHROUTE_VALUE_MEDITATION
    case 121888:
    case 122277:
      return WISHROUTE_VALUE_METAPHYSICS
    case 119556:
      return WISHROUTE_VALUE_EXPANDED_CONSCIOUSNESS
    case 121943:
    case 122271:
      return WISHROUTE_VALUE_FITNESS
    case 121892:
    case 122280:
      return WISHROUTE_VALUE_SPIRITUAL_GROWTH
    case 121939:
    case 122282:
      return WISHROUTE_VALUE_YOGA_LEVEL_BEGINNER
    case 121940:
    case 122283:
      return WISHROUTE_VALUE_YOGA_LEVEL_INTERMEDIATE
    case 121941:
    case 122284:
      return WISHROUTE_VALUE_YOGA_LEVEL_ADVANCED
    case 121905:
    case 121899:
    case 122304:
    case 122286:
      return WISHROUTE_VALUE_ENERGIZED
    case 121900:
    case 122288:
      return WISHROUTE_VALUE_BENDY_FLEXIBLE
    case 121907:
    case 121901:
    case 122306:
    case 122290:
      return WISHROUTE_VALUE_READY_BED
    case 121904:
    case 121898:
    case 122291:
    case 122303:
      return WISHROUTE_VALUE_STRESS_FREE
    case 121897:
    case 122287:
      return WISHROUTE_VALUE_FIT_STRONG
    case 121906:
    case 122305:
      return WISHROUTE_VALUE_PRESENT
    case 121903:
    case 122302:
      return WISHROUTE_VALUE_FOCUSED
    case 121910:
    case 122326:
      return WISHROUTE_VALUE_EASTERN_ARTS
    case 121914:
    case 122328:
      return WISHROUTE_VALUE_WEIGHT_TRAIN
    case 121911:
    case 122325:
      return WISHROUTE_VALUE_DANCE_FITNESS
    case 121913:
    case 122324:
      return WISHROUTE_VALUE_STRETCH
    case 121909:
    case 122327:
      return WISHROUTE_VALUE_PILATES
    case 121912:
    case 122323:
      return WISHROUTE_VALUE_CARDIO
    default:
      return WISHROUTE_VALUE_NOT_SURE
  }
}

export function createWishrouteOptionsList (existingOptions, newOptions) {
  // I believe that in immutable version 3.8 that merging 2 Lists doesn't work as expected
  // so using this unioin solution instead
  return existingOptions.toSet().union(newOptions.toSet()).toList()
}

export function formatWishrouteSignupData (data) {
  const {
    eventType,
    userName,
    focusAreas,
    options,
    zoneinfo,
    phone,
  } = data
  const phoneData = formatPhone(phone) || {}
  const phoneNumber = _get(phoneData, 'phoneNumber', '')
  // There are 3 yoga levels
  const yogaLevel = options.filter((option) => {
    return (
      option === WISHROUTE_VALUE_YOGA_LEVEL_BEGINNER
      || option === WISHROUTE_VALUE_YOGA_LEVEL_INTERMEDIATE
      || option === WISHROUTE_VALUE_YOGA_LEVEL_ADVANCED
    )
  }).first()
  // Anything other than the yoga levels will be considered a style
  const style = options.filter((option) => {
    return (
      option !== WISHROUTE_VALUE_YOGA_LEVEL_BEGINNER
      && option !== WISHROUTE_VALUE_YOGA_LEVEL_INTERMEDIATE
      && option !== WISHROUTE_VALUE_YOGA_LEVEL_ADVANCED
    )
  }).first()

  const dataObject = {
    eventType,
    phone: phoneNumber,
    userName,
    zoneinfo,
    focusAreas: focusAreas.toJS(),
    ...(yogaLevel && { yogaLevel }),
    ...(style && { style }),
  }

  return dataObject
}

export async function wishrouteSignup (options = {}) {
  try {
    const { auth, data } = options
    const formattedData = formatWishrouteSignupData(data)

    const res = await apiPost('v1/user/discovery-coaching', formattedData, { auth }, TYPE_BROOKLYN_JSON)
    return _get(res, 'body')
  } catch (err) {
    return { success: false, opt_in: false }
  }
}
